module.exports = __webpack_public_path__ + "static/media/logo.e4d97775.png";